import React, {useMemo} from 'react';

import {CreditItem} from './credit-item';

import type {Contract} from 'src/openapi/admin/models/Contract';
import type {CreditAlertInfo} from 'src/openapi/admin/models/CreditAlertInfo';

type Props = {
    data: Array<CreditAlertInfo>,
    onRemove: (contractId: number, credit: number) => void,
    contracts: Array<Contract>,
    disabled?: boolean,
};
export const CreditsList = ({data, onRemove, contracts, disabled}: Props) => {
    const contractsMapping = useMemo(() =>
        contracts.reduce((memo, contract) => {
            const contractId = contract.contractId;
            if (typeof contractId === 'number') {
                memo[contractId] = contract.contractNumber;
            }
            return memo;
        }, {} as {[key: number]: string}), [contracts]);

    return (
        <>
            {data.map(item =>
                item.creditsBelow.map((credit, idx) => (
                    <CreditItem
                        showCaption={idx === 0}
                        key={item.contractId + credit}
                        contractNumber={contractsMapping[item.contractId]}
                        contractId={item.contractId}
                        credit={credit}
                        onRemove={onRemove}
                        disabled={disabled}
                    />
                ),
                ))}
        </>
    );
};
